import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import RegisterForm from './RegisterForm';

/**
 * Modale d'inscription
 */
const RegisterModal = ({ isOpen, onClose, onSwitchToLogin }) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onSwitchToLogin();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('auth.register')}>
      <RegisterForm 
        onSuccess={handleSuccess}
        onModeChange={(mode) => mode === 'login' && onSwitchToLogin()}
      />
    </Modal>
  );
};

export default RegisterModal;
